/**
 * Huit catégories par défaut (alignées backend / création tenant) pour preuves et activités RACI.
 */

export const DEFAULT_ORGANIZATION_DOCUMENT_CATEGORY_DEFINITIONS = [
  { label: "Gouvernance", description: "Pilotage, politiques et validation stratégique RGPD." },
  { label: "Sous-traitance", description: "Encadrement des sous-traitants et obligations art. 28." },
  { label: "Droits des personnes", description: "Exercice des droits des personnes concernées (accès, effacement, etc.)." },
  { label: "Incidents", description: "Violations de données et gestion des crises." },
  { label: "Transferts", description: "Transferts hors EEE, clauses types et analyses de transfert." },
  { label: "Documentation", description: "PIA, registres, procédures et autres éléments documentés." },
  { label: "Infrastructure & hébergement", description: "Hébergement, sauvegardes et continuité du service." },
  { label: "Sécurité applicative", description: "Sécurité logicielle, développement sécurisé et durcissement." },
];

const FALLBACK_PALETTE = [
  { color: "#1d4ed8", bg: "#eff6ff" },
  { color: "#7c3aed", bg: "#f5f3ff" },
  { color: "#059669", bg: "#ecfdf5" },
  { color: "#dc2626", bg: "#fef2f2" },
  { color: "#0891b2", bg: "#ecfeff" },
  { color: "#b45309", bg: "#fffbeb" },
  { color: "#4f46e5", bg: "#eef2ff" },
  { color: "#0d9488", bg: "#f0fdfa" },
];

/** Modèle liste API + démo hors connexion */
export function buildFallbackCategoriesWithStyles() {
  return DEFAULT_ORGANIZATION_DOCUMENT_CATEGORY_DEFINITIONS.map((def, i) => ({
    id: i + 1,
    label: def.label,
    description: def.description,
    ...FALLBACK_PALETTE[i % FALLBACK_PALETTE.length],
    isSystemDefault: true,
    usageCount: 0,
  }));
}

export const DEFAULT_FIRST_ORGANIZATION_CATEGORY_LABEL = DEFAULT_ORGANIZATION_DOCUMENT_CATEGORY_DEFINITIONS[0]?.label ?? "Gouvernance";

/** Libellés des 8 catégories système (détection legacy si le flag API manque). */
export const DEFAULT_ORGANIZATION_CATEGORY_LABEL_SET = new Set(
  DEFAULT_ORGANIZATION_DOCUMENT_CATEGORY_DEFINITIONS.map(d => d.label)
);

/**
 * Catégorie non supprimable côté métier : flag serveur explicite, ou legacy sans flag mais libellé canonique.
 */
export function isLockedOrganizationCategory(c) {
  if (!c) return false;
  if (c.isSystemDefault === true) return true;
  if (c.isSystemDefault === false) return false;
  return DEFAULT_ORGANIZATION_CATEGORY_LABEL_SET.has(c.label);
}

export function categoryBadgeStylesFromCategories(categories) {
  return Object.fromEntries(
    (categories || []).map(c => [
      c.label,
      {
        color: c?.color || "#475569",
        bg: c?.bg || "#f1f5f9",
      },
    ])
  );
}
